import React, { useEffect, useRef, useState } from 'react'
import '../../assets/style/main.css'
import './style.scss'
import PageLoader from '../../components/PageLoader'
import { isPageLoading } from '../../components/PageLoader'
import CROSS_ICON from "../../assets/images/icons/x.png"
import SHIELD_ICON from "../../assets/images/icons/ShieldCheck.png"
import { Base_API } from '../../_actions/matcher'
import ContentLoader from '../../components/ContentLoader'
import { isContentLoading } from '../../components/ContentLoader'
import { EncryptedText, DecryptedText, EncryptedOBJ, DecryptedOBJ } from '../../utils/Encryption'
import moment from 'moment/moment'
import $ from 'jquery'
import Swal from 'sweetalert2'
import withReactContent from 'sweetalert2-react-content'
import { NhealthAction } from '../../_actions/action.api'
const MySwal = withReactContent(Swal)
import CLOSE_ICON from '../../assets/images/icons/close-btn-2.png'
import { JWTAuthen, SignInPhone, updateKYCPatient } from '../../_actions/sso.authen'

function SignIn_OTP() {
    let onceMount = useRef(true);
    let INPUT_OTP = useRef(null);

    const initialTimeLeft = 300;
    const [timeLeft, setTimeLeft] = useState(0);
    const [resendOTP, setResendOTP] = useState(false);
    const [regisInfo, setRegisInfo] = useState(null);
    const [otp, setOTP]= useState({
        otp: "",
        _refotp: "",
        _refverify: ""
    });
    const [otpBy, setOTPby] = useState(null); 
    const [JWT, setJWT] = useState(null);

    const leadingZero = (num) => (num < 10 ? "0" + num : num);

    const minutes = Math.floor(timeLeft / 60);
    const seconds = timeLeft % 60;

    useEffect(() => {
        if(onceMount.current)
        {
            pageInit();
            onceMount.current = false;
        }
    }, [])

    useEffect(() => {
    
        const intervalId = setInterval(() => {
          setTimeLeft(timeLeft - 1);
        }, 1000);
    
        // Clear Count Time
        if (timeLeft === 0) {
          clearInterval(intervalId) 
          setResendOTP(true);
        }else
        {
          setResendOTP(false);
        }
    
        return () => clearInterval(intervalId);
    }, [timeLeft]);

    const pageInit = async() => {
        await jwtInit(); 
        let userData = await getRegisInfo(); 
        console.log('userData: ', userData);
        await otpInit(userData);
        await checkCurrentURL();
        isPageLoading(false);
    }

    const jwtInit = () => {
        return new Promise(async resolve => {
            await getJWT()
            .then(() => {
                resolve();
            })
        })
    }

    const getJWT_Patient = () => {
        return new Promise(async resolve => {
            let ip = await NhealthAction.GetIPAdress();
            let patientData = !!localStorage.getItem(process.env.REACT_APP_ENC_NAME_PATIENT_PROFILE_DATA) ? DecryptedOBJ(localStorage.getItem(process.env.REACT_APP_ENC_NAME_PATIENT_PROFILE_DATA)) : null;
            let patientID = patientData.data.patientid;
            console.log('patient: ',patientData);

            let reqData = {
                UserRef: patientID,
                IPAddress: ip,
                Channal: process.env.REACT_APP_ENC_NAME_CHANNEL_REF
            } 
            NhealthAction.JWT_Authen(reqData)
            .then(res => {
                console.log('jwt: ', res)
                if(!!res)
                {
                    setJWT(res);
                    localStorage.setItem(process.env.REACT_APP_ENC_NAME_JWT_DATA, EncryptedOBJ(res));
                    resolve(res);
                }
            })
        })
    }
    const getJWT = () => {
        return new Promise(async resolve => {
            let ip = await NhealthAction.GetIPAdress();
            let lineProfile = !!localStorage.getItem('line_profile') ? DecryptedOBJ(localStorage.getItem('line_profile')) : null;
            console.log(lineProfile);
            let udid = lineProfile.user_id;

            if(!!lineProfile)
            {
                let reqData = {
                    UserRef: udid,
                    IPAddress: ip,
                    Channal: process.env.REACT_APP_ENC_NAME_CHANNEL_REF
                } 
                NhealthAction.JWT_Authen(reqData)
                .then(res => {
                    console.log('jwt: ', res)
                    if(!!res)
                    {
                        setJWT(res);
                        localStorage.setItem(process.env.REACT_APP_ENC_NAME_JWT_DATA, EncryptedOBJ(res));
                        resolve(res);
                    }
                })
            }else
            {
                console.error('Line profile is required!');
            }
        })
    }

    const otpInit = (userData) => {
        return new Promise(async resolve => {
            let raw_otp_old_starttime = localStorage.getItem(process.env.REACT_APP_ENC_NAME_OTP_START_TIME);
        
            if (!!raw_otp_old_starttime) {
                let dec_otp_old_starttime = DecryptedText(raw_otp_old_starttime);
                let otpOldStartTime = moment(dec_otp_old_starttime, 'DD-MM-YYYY HH:mm:ss.SSS');
        
                let diffInMilliseconds = moment().diff(otpOldStartTime);
                let diffInSeconds = Math.floor(diffInMilliseconds / 1000);
        
                if (diffInSeconds < initialTimeLeft) {
                    // Continue countdown
                    let raw_otp_data = localStorage.getItem(process.env.REACT_APP_ENC_NAME_OTP_DATA);
                    let dec_otp_data = DecryptedOBJ(raw_otp_data);
            
                    setOTP({...otp, _refotp: dec_otp_data._refotp, _refverify: dec_otp_data._refverify});      
                    setTimeLeft(initialTimeLeft - diffInSeconds); // Set the remaining time in seconds
                } else {
                    // Reset countdown & Resend OTP
                    await getOTP(userData);
                }
        
            } else {
                // Resend OTP
                console.log('OTP start time not present');
                await getOTP(userData);
            }
      
            resolve();
        });
    };

    const getRegisInfo = () => {
        return new Promise(async resolve => {
            let lineProfile = !!localStorage.getItem('line_profile') ? DecryptedOBJ(localStorage.getItem('line_profile')) : null;
            let phoneNumber = await getMember(lineProfile.user_id);
            //! bypass
            let receiver_data = {receiver: phoneNumber};
            // let receiver_data = {receiver: '0830174167'};
            console.log('raw line profile: ', localStorage.getItem('line_profile')); 
            console.log('Line Profile: ', lineProfile);

            setOTPby('phone_number');
            setRegisInfo(receiver_data);
            resolve(receiver_data);
        })
    }
    const getMember = (user_id) => {
        return new Promise(async resolve => {
            NhealthAction.GetMember(user_id)
            .then(async res => {
                console.log('Get Member: ', res.member);
                if(res.isSuccess === true)
                {
                    resolve(res.member.Phoneno);
                }
            })
        })    
    }

    const checkCurrentURL = () => {
        return new Promise(async resolve => {
            let enc_currentpage_url = localStorage.getItem(process.env.REACT_APP_ENCNAME_CURRENTPAGEURL)
            let pathname = location.pathname;

            if(!!enc_currentpage_url)
            {
                let dec_currentpage_url = DecryptedText(enc_currentpage_url);
                if(pathname !== dec_currentpage_url)
                {
                    // set new
                    localStorage.setItem(process.env.REACT_APP_ENCNAME_CURRENTPAGEURL, EncryptedText(pathname));
                    localStorage.setItem(process.env.REACT_APP_ENCNAME_CAMEFROM_URL, EncryptedText(pathname));
                    // navigate
                    location.reload();
                }
            }else
            {
                // set new
                localStorage.setItem(process.env.REACT_APP_ENCNAME_CURRENTPAGEURL, EncryptedText(pathname));
                localStorage.setItem(process.env.REACT_APP_ENCNAME_CAMEFROM_URL, EncryptedText(pathname));
            }
            resolve();
        })
    }

    const onChange = async(e) => {
        let value = e.target.value; 
        let length = value.length;

        setOTP({
            ...otp,
            otp: value
        }) 
        
        // clear style
        $(`.pin[index="1"]`).css({"border": "1px solid #E7E7E7"});  
        $(`.pin[index="2"]`).css({"border": "1px solid #E7E7E7"});  
        $(`.pin[index="3"]`).css({"border": "1px solid #E7E7E7"});  
        $(`.pin[index="4"]`).css({"border": "1px solid #E7E7E7"});  
        $(`.pin[index="5"]`).css({"border": "1px solid #E7E7E7"});  
        $(`.pin[index="6"]`).css({"border": "1px solid #E7E7E7"});  
        // clear input
        $(`.pin[index="1"]`).text("");  
        $(`.pin[index="2"]`).text("");  
        $(`.pin[index="3"]`).text("");  
        $(`.pin[index="4"]`).text("");  
        $(`.pin[index="5"]`).text("");  
        $(`.pin[index="6"]`).text("");  

        if(length > 0)
        {
            // let lastValue = value.slice(length-1, length);
            // $(`.pin[index="${length}"]`).text(lastValue);

            let value_split = value.split('');
            value_split.map((item, i) => {
                $(`.pin[index="${i+1}"`).text(item);
            })
        }

        if(length >= 6)
        {
            isContentLoading(true)

            // LocalStorage (Remove)
            localStorage.removeItem(process.env.REACT_APP_ENC_NAME_OTP_START_TIME);
            localStorage.removeItem(process.env.REACT_APP_ENC_NAME_OTP_DATA);

            await verifyOTP_SSO()
            .then(async() => {
                nextPage();
            })
        }else
        {
            $(`.pin[index="${length+1}"]`).css({"border": "2px solid #007AFF"});
        }
    }

    const nextPage = () => {
        localStorage.removeItem('line_profile');
        location.href = `${Base_API.pathWeb}/n-health/signin/connect-verify`;
    }

    const patientRegister = () => {
        return new Promise(async resolve => {
            let lineProfile = !!localStorage.getItem('line_profile') ? DecryptedOBJ(localStorage.getItem('line_profile')) : null;
            let udid = lineProfile.user_id;
            let jwtEnc = localStorage.getItem(process.env.REACT_APP_ENC_NAME_JWT_DATA);
            let jwtData = DecryptedOBJ(jwtEnc);
            
            let headers = {
                token: jwtData.token,
                userRef: udid,
                authorizeRef: jwtData.authorizeRef,
                channalRef: jwtData.channalRef
            }

            let signin_data_enc = localStorage.getItem(process.env.REACT_APP_ENC_NAME_SIGNIN_RESPONSE); 
            let dataRegisEnc = localStorage.getItem(process.env.REACT_APP_ENC_NAME_REGIS_PAYLOAD);
            let typeRegisEnc = localStorage.getItem(process.env.REACT_APP_ENC_NAME_TYPE_REGIS)

            if(!!signin_data_enc && !!dataRegisEnc && !!typeRegisEnc)
            {
                let dataRegis = DecryptedOBJ(dataRegisEnc);
                let signInData = DecryptedOBJ(signin_data_enc);
                let typeRegis = DecryptedText(typeRegisEnc);
                let dob = dataRegis.dob.split('-');
                let gender = dataRegis.gender === 'female' ? 'F' : 'M'
                let identityPathURL = !!localStorage.getItem(process.env.REACT_APP_ENC_NAME_IDCARD_IMAGE_URL) ? localStorage.getItem(process.env.REACT_APP_ENC_NAME_IDCARD_IMAGE_URL) : "";

                console.log(dataRegis);

                let rawReq = {
                    "refEXP": signInData.refEXP,
                    "isType": signInData.isType,
                    "refAction": signInData.refAction,
                    "refType": signInData.refType,
                    "data": {
                        "identity_id": dataRegis.cardid,
                        "lasercode": dataRegis.back_idcard,
                        "isForeign": typeRegis === 'passport' ? true : false,
                        "name_th": dataRegis.first_name_th,
                        "surname_th": dataRegis.last_name_th,
                        "name_en": dataRegis.first_name_en,
                        "surname_en": dataRegis.last_name_en,
                        "identity_image": identityPathURL,
                        "ihuman_image": "",
                        "dob_day": Number(dob[0]),
                        "dob_month": Number(dob[1]),
                        "dob_year": Number(dob[2]),
                        "gender": gender,
                        "phonenumber": dataRegis.phone_number,
                        "email": dataRegis.email
                    },
                }
                let reqData = {
                    data: EncryptedOBJ(rawReq)
                }
                console.log('raw req (register): ', rawReq);

                NhealthAction.PatientRegis(reqData, headers)
                .then(res => {
                    if(res.IsSuccess)
                    {
                        localStorage.setItem(process.env.REACT_APP_ENC_NAME_SIGNIN_RESPONSE, EncryptedOBJ(res)) 
                        resolve();
                    }
                })
            } 
        })
    }

    const verifyOTP_SSO = () =>{
        return new Promise(async resolve => {
            let lineProfile = !!localStorage.getItem('line_profile') ? DecryptedOBJ(localStorage.getItem('line_profile')) : null;
            let udid = lineProfile.user_id;
            let jwtData = await JWTAuthen()

            let headers = {
                token: jwtData.token,
                userRef: udid,
                authorizeRef: jwtData.authorizeRef,
                channalRef: jwtData.channalRef
            }

            let signin_data_enc = localStorage.getItem(process.env.REACT_APP_ENC_NAME_SIGNIN_RESPONSE); 
            if(!!signin_data_enc)
            {
                let signInData = DecryptedOBJ(signin_data_enc);
                console.log(signInData);
                let rawReq = {
                    "refEXP": signInData.refEXP,
                    "isType": signInData.isType,
                    "refAction": signInData.refAction,
                    "refType": signInData.refType,
                    "_otp": INPUT_OTP.current.value,
                    "_refotp": otp._refotp,
                    "_refverify": otp._refverify
                }
                console.log('verify otp(raw req): ', rawReq);

                let reqData ={
                    "data": EncryptedOBJ(rawReq)
                }
    
                NhealthAction.verifyOTP_SSO(reqData, headers)
                .then(res => {
                    if(res.IsSuccess)
                    {
                        console.log('verify otp success: ', res)
                        localStorage.setItem(process.env.REACT_APP_ENC_NAME_SIGNIN_RESPONSE, EncryptedOBJ(res)) 
                        resolve();
                    }else
                    {
                        openAlert('ไม่สำเร็จ', 'OTP ไม่ถูกต้อง', 'ลองอีกครั้ง');
                        setOTP({...otp, otp: ''}) 
                        // clear input
                        $(`.pin[index="1"]`).text("");  
                        $(`.pin[index="2"]`).text("");  
                        $(`.pin[index="3"]`).text("");  
                        $(`.pin[index="4"]`).text("");  
                        $(`.pin[index="5"]`).text("");  
                        $(`.pin[index="6"]`).text(""); 
                        isContentLoading(false);
                    }
                })
            }
        })
    }
    const verifyOTP_SSO_KYC = () =>{
        return new Promise(async resolve => {
            let patientData = !!localStorage.getItem(process.env.REACT_APP_ENC_NAME_PATIENT_PROFILE_DATA) ? DecryptedOBJ(localStorage.getItem(process.env.REACT_APP_ENC_NAME_PATIENT_PROFILE_DATA)) : null;
            let patientID = patientData.data.patientid;
            let jwtEnc = localStorage.getItem(process.env.REACT_APP_ENC_NAME_JWT_DATA);
            let jwtData = DecryptedOBJ(jwtEnc);

            let headers = {
                token: jwtData.token,
                userRef: patientID,
                authorizeRef: jwtData.authorizeRef,
                channalRef: jwtData.channalRef
            }

            if(!!patientData)
            {
                let rawReq = {
                    "refEXP": patientData.refEXP,
                    "isType": patientData.isType,
                    "refAction": patientData.refAction,
                    "refType": patientData.refType,
                    "_otp": INPUT_OTP.current.value,
                    "_refotp": otp._refotp,
                    "_refverify": otp._refverify
                }
                console.log('verify otp(raw req): ', rawReq);

                let reqData ={
                    "data": EncryptedOBJ(rawReq)
                }
    
                NhealthAction.verifyOTP_SSO(reqData, headers)
                .then(res => {
                    if(res.IsSuccess)
                    {
                        console.log('verify otp success: ', res)
                        localStorage.setItem(process.env.REACT_APP_ENC_NAME_SIGNIN_RESPONSE, EncryptedOBJ(res)) 
                        resolve(res);
                    }else
                    {
                        openAlert('ไม่สำเร็จ', 'OTP ไม่ถูกต้อง', 'ลองอีกครั้ง');
                        setOTP({...otp, otp: ''}) 
                        // clear input
                        $(`.pin[index="1"]`).text("");  
                        $(`.pin[index="2"]`).text("");  
                        $(`.pin[index="3"]`).text("");  
                        $(`.pin[index="4"]`).text("");  
                        $(`.pin[index="5"]`).text("");  
                        $(`.pin[index="6"]`).text(""); 
                        isContentLoading(false);
                    }
                })
            }
        })
    }

    const onClickPin = () => {
        let length = $('input#otp').val().length;
        $(`.pin[index="${length+1}"]`).css({"border": "2px solid #007AFF"});
    }

    const onBlur = () => {
        // clear style
        $(`.pin[index="1"]`).css({"border": "1px solid #E7E7E7"});  
        $(`.pin[index="2"]`).css({"border": "1px solid #E7E7E7"});  
        $(`.pin[index="3"]`).css({"border": "1px solid #E7E7E7"});  
        $(`.pin[index="4"]`).css({"border": "1px solid #E7E7E7"});  
        $(`.pin[index="5"]`).css({"border": "1px solid #E7E7E7"});  
        $(`.pin[index="6"]`).css({"border": "1px solid #E7E7E7"});   
    }

    const reGetOTP = async() => { // ที่ต้อง duplicate function ทั้งที่มันทำงานเหมือนกัน เพราะ ตอนเข้าครั้งแรก state(phone number เซทไม่ทัน) // T.T
        if(resendOTP === true)
        {
            //! For Prod 
            setResendOTP(false);
            let otpData = await reSendOTP();
            if(!!otpData._refotp)
            {
                // Set Local Storage
                localStorage.setItem(process.env.REACT_APP_ENC_NAME_OTP_DATA, EncryptedOBJ(otpData));
        
                // Set Count Time
                let currentTimestamp = moment().format('DD-MM-YYYY HH:mm:ss.SSS');
                let enc_currentTimestamp = EncryptedText(currentTimestamp);
                localStorage.setItem(process.env.REACT_APP_ENC_NAME_OTP_START_TIME, enc_currentTimestamp);
                setTimeLeft(initialTimeLeft);
        
                setOTP({...otp, _refotp: otpData._refotp, _refverify: otpData._refverify});      
            }else
            {
                if(otpData.ErrMessage === "maximum requested")
                {
                    openAlert("ผิดพลาด", "ไม่สามารถขอรหัส OTP ได้ในขณะนี้ กรุณาลองใหม่ภายหลัง");
                }
            }

            //! For Development 
            // Set Count Time
            // let currentTimestamp = moment().format('DD-MM-YYYY HH:mm:ss.SSS');
            // let enc_currentTimestamp = EncryptedText(currentTimestamp);
            // localStorage.setItem(process.env.REACT_APP_ENC_NAME_OTP_START_TIME, enc_currentTimestamp);
            // localStorage.setItem(process.env.REACT_APP_ENC_NAME_OTP_DATA, EncryptedOBJ(otp));
            // setTimeLeft(initialTimeLeft);
        }
    }

    function reSendOTP()
    {
        return new Promise(async (resolve, reject) => {
            await sendOTPSMS()
            .then(res => {
                resolve(res);
            })
        });
    }

    const getOTP = async(userData) => {
        return new Promise(async resolve => {
            let otpData = await sendOTP(userData);
            if(!!otpData._refotp)
            {
                // Set Local Storage
                localStorage.setItem(process.env.REACT_APP_ENC_NAME_OTP_DATA, EncryptedOBJ(otpData));
        
                // Set Count Time
                let currentTimestamp = moment().format('DD-MM-YYYY HH:mm:ss.SSS');
                let enc_currentTimestamp = EncryptedText(currentTimestamp);
                localStorage.setItem(process.env.REACT_APP_ENC_NAME_OTP_START_TIME, enc_currentTimestamp);
                setTimeLeft(initialTimeLeft);
                setOTP({...otp, _refotp: otpData._refotp, _refverify: otpData._refverify});      
        
                resolve();
            }else
            {
                if(otpData.ErrMessage === "maximum requested")
                {
                    openAlert("ผิดพลาด", "ไม่สามารถขอรหัส OTP ได้ในขณะนี้ กรุณาลองใหม่ภายหลัง");
                }
                resolve();
            }
        })
    }

    function sendOTP(userData)
    {
        return new Promise(async (resolve, reject) => {
            await sendOTPSMS(userData)
            .then(res => {
                resolve(res);
            })
            // if(dec_type_otp === 'login')
            // {
            //     let raw_type_signin = localStorage.getItem(process.env.REACT_APP_ENC_NAME_TYPE_SIGNIN)
            //     let dec_type_signin = DecryptedText(raw_type_signin);
        
            //     if(dec_type_signin === 'phone_number')
            //     {
            //         let phoneEnc = EncryptedText(receiver);
            //         let reqData = { "data" : phoneEnc } // = 1 (type number)
        
            //         await sendOTPSMS(reqData)
            //         .then(res => {
            //             resolve(res);
            //         })
            //     }
            //     if(dec_type_signin === 'email')
            //     {
            //         let emailEnc = EncryptedText(receiver);
            //         let reqData = { "data" : emailEnc } // = 1 (type number)
        
            //         await sendOTPEmail(reqData)
            //         .then(res => {
            //             resolve(res);
            //         })
            //     }
            // }
        })
    }

    const sendOTPSMS = (userData) => {
        return new Promise(async resolve => {
            let jwtData = await JWTAuthen();
            let signInData = await SignInPhone(jwtData, userData.receiver);

            let rawReq = {
                "refEXP": signInData.refEXP,
                "isType": signInData.isType,
                "refAction": signInData.refAction,
                "refType": signInData.refType
            }
            console.log('get otp(raw req): ', rawReq);
            let reqData = {
                "data": EncryptedOBJ(rawReq)
            }

            let lineProfile = !!localStorage.getItem('line_profile') ? DecryptedOBJ(localStorage.getItem('line_profile')) : null;
            let udid = lineProfile.user_id;
            let jwtData2 = await JWTAuthen();
            let headers = {
                token: jwtData2.token,
                userRef: udid,
                authorizeRef: jwtData2.authorizeRef,
                channalRef: jwtData2.channalRef
            }
            console.log(headers);
            
            NhealthAction.SendOTP_SMS_SSO(reqData, headers)
            .then(res => {
                console.log('get otp: ', res);
                if(res.IsSuccess)
                {
                    resolve(res.data);
                }else
                {
                    if(res.ErrMessage === "maximum requested")
                    {
                        openAlert('ไม่สำเร็จ', 'ท่านขอหมายเลข OTP มากเกินในเวลาที่กำหนด กรุณารอทำรายการใหม่ในอีก 5 นาที', 'ตกลง');
                    }        
                }
            })
            
        })
    }
    const sendOTPEmail = (reqData) => {
        return new Promise(async resolve => {
            NhealthAction.SendOTP_Email_SSO(reqData)
            .then(res => {
                console.log('Send OTP Email: ', res);
                if(res.IsSuccess)
                {
                resolve(res.data);
                }
            })
        })
    }

    const handleResetClick = () => {
        // Resend OTP
        reGetOTP();
    };

    const handleInputChange = async(e) => {
        const input = e.target.value;
        const numericValue = input.replace(/\D/g, '');    
        setOTP({...otp, otp: numericValue})
    
        if(numericValue.length === 6)
        {
            await verifyOTP(numericValue)
            .then(() => {
                nextPage();
            }) 
            .catch(() => {
                openAlert('ไม่สำเร็จ', 'OTP ไม่ถูกต้อง', 'ลองอีกครั้ง');
            })
        }
    };

    function verifyOTP(OTP) {
        let raw_otp_data = localStorage.getItem(
            import.meta.env.VITE_DATA_ENC_NAME_OTP_DATA
        );
        let dec_otp_data = DecryptedOBJ(raw_otp_data);
    
        let rawReq = {
            _otp: OTP,
            _refotp: dec_otp_data._refotp,
            _refverify: dec_otp_data._refverify,
        };
        let reqData = {
            data: EncryptedOBJ(rawReq),
        };
    
        return new Promise(async (resolve, reject) => {
            APIS_ACTION.VerifyOTP(reqData).then((res) => {
                console.log(res);
                if (res.IsSuccess) {
                    localStorage.setItem(import.meta.env.VITE_DATA_ENC_NAME_REF_USER, EncryptedText(res.data.data));
                    resolve();
                }else
                {
                    reject();
                }
            });
        });
    }

    const openAlert = (title, body, button) => {
        let alertConfirmElem = (
            <div className="swal-cfpm">
                <div className="top">
                    <img onClick={handleCloseAlert} src={CLOSE_ICON} />
                </div>
        
                <div className="mid">
                    <h2 className="title">{title}</h2>
                    <p className="desc">
                        {body}
                    </p>
                </div>
        
                <div className={`bottom`}>
                    <button type="button" onClick={handleCloseAlert}>
                        {button}
                    </button>
                </div>
            </div>
        );
    
        MySwal.fire({
            html: alertConfirmElem,
            showCancelButton: false,
            showConfirmButton: false,
            allowOutsideClick: false,
        });
    
    };
    
    const handleCloseAlert = () => {
        MySwal.close();
    };

    return (
        <div className='signup-otp-con'>
            <PageLoader />
            <ContentLoader />

            <div className="nav">
                <div className="close">
                    <img src={CROSS_ICON} />
                </div>
            </div> 
            <img src={SHIELD_ICON} className='cover' />

            <h2 className="title">
                ตรวจสอบเพื่อยืนยัน OTP
            </h2>
            <p className='sub-title'>เราได้ส่งรหัส OTP ผ่านทาง {otpBy === 'phone_number' ? 'SMS' : 'Email'} ไปยัง {otpBy === 'phone_number' ? 'เบอรโทรศัพท์' : ''} <br /> <span>{!!regisInfo && regisInfo.receiver}</span></p>

            <div className="pin-wrap">
                    <div className="pin-group">
                    <label htmlFor="otp" className='pin' index="1"></label>
                    <label htmlFor="otp" className='pin' index="2"></label>
                    <label htmlFor="otp" className='pin' index="3"></label>
                    <span>-</span>
                    <label htmlFor="otp" className='pin' index="4"></label>
                    <label htmlFor="otp" className='pin' index="5"></label>
                    <label htmlFor="otp" className='pin' index="6"></label>
                </div>

                <input 
                    type="number" 
                    id='otp' 
                    onChange={onChange} 
                    onBlur={onBlur}
                    value={otp.otp}
                    ref={INPUT_OTP}
                    onFocus={onClickPin}
                />
            </div>

            <p className="otp-ref">หมายเหตุ รหัส OTP : {otp._refotp}</p>
            <h3 className="time-count">
                {leadingZero(minutes)}:{leadingZero(seconds)}
            </h3>
            <p className={`resend ${resendOTP ? "" : "disabled"}`} onClick={resendOTP ? handleResetClick : null}>ส่งรหัส OTP อีกครั้ง</p>
        </div>
    )
}

export default SignIn_OTP